function buildTreeIndex(options) {
    const index = new Map();
    const visit = (node, parent) => {
        var _a;
        index.set(node.value, { node, parent });
        (_a = node.items) === null || _a === void 0 ? void 0 : _a.forEach((child) => visit(child, node));
    };
    options.forEach((option) => visit(option));
    return index;
}
function uniqueAppend(base, additions) {
    const set = new Set(base);
    const next = [...base];
    additions.forEach((value) => {
        if (set.has(value))
            return;
        set.add(value);
        next.push(value);
    });
    return next;
}
function descendantValues(option) {
    var _a, _b;
    const values = [];
    const stack = [...((_a = option.items) !== null && _a !== void 0 ? _a : [])];
    while (stack.length > 0) {
        const node = stack.pop();
        if (!node)
            continue;
        values.push(node.value);
        if ((_b = node.items) === null || _b === void 0 ? void 0 : _b.length)
            stack.push(...node.items);
    }
    return values;
}
export function selectedLeafCount(options, selectedValues) {
    const index = buildTreeIndex(options);
    return selectedValues.reduce((count, value) => {
        var _a;
        const entry = index.get(value);
        if (!entry)
            return count;
        if (!((_a = entry.node.items) === null || _a === void 0 ? void 0 : _a.length))
            return count + 1;
        const leafs = descendantValues(entry.node).filter((descendantValue) => {
            var _a;
            const descendantEntry = index.get(descendantValue);
            return descendantEntry != null && !((_a = descendantEntry.node.items) === null || _a === void 0 ? void 0 : _a.length);
        });
        return count + leafs.length;
    }, 0);
}
export function reconcileTreeSelection(options, currentValue, toggledOption) {
    var _a, _b, _c;
    const index = buildTreeIndex(options);
    const currentSet = new Set(currentValue);
    const toggledEntry = index.get(toggledOption.value);
    const node = (_a = toggledEntry === null || toggledEntry === void 0 ? void 0 : toggledEntry.node) !== null && _a !== void 0 ? _a : toggledOption;
    const parent = toggledEntry === null || toggledEntry === void 0 ? void 0 : toggledEntry.parent;
    if ((_b = node.items) === null || _b === void 0 ? void 0 : _b.length) {
        const descendants = descendantValues(node);
        const withoutParentAndChildren = currentValue.filter((value) => value !== node.value && !descendants.includes(value));
        if (currentSet.has(node.value)) {
            // Rule 4: deselecting parent removes parent + descendants.
            return withoutParentAndChildren;
        }
        // Rule 3: selecting parent removes individually selected descendants and adds parent.
        return uniqueAppend(withoutParentAndChildren, [node.value]);
    }
    if (currentSet.has(node.value)) {
        // Rule 2: deselecting a directly selected child (without parent selected) removes it.
        return currentValue.filter((value) => value !== node.value);
    }
    if (parent && currentSet.has(parent.value)) {
        // Rule 1: parent selected + child toggled => replace parent with all siblings except toggled child.
        const withoutParent = currentValue.filter((value) => value !== parent.value && value !== node.value);
        const siblingValues = ((_c = parent.items) !== null && _c !== void 0 ? _c : []).filter((item) => item.value !== node.value).map((item) => item.value);
        return uniqueAppend(withoutParent, siblingValues);
    }
    return uniqueAppend(currentValue, [node.value]);
}
